module.exports = __webpack_public_path__ + "static/media/caixa.be49c137.png";